import React from "react";
import { Link } from "react-router-dom";
import LogoWhite from '../img/thumb/logo-white.png';
import IconPdf from "../img/icons/icon-pdf.svg";
import IconQuote from "../img/icons/icon-quotes.svg";
import Photo1920x656_1 from "../img/thumb/photo-1920x656--1.jpg";
import Photo1920x656_2 from "../img/thumb/photo-1920x656--2.jpg";
import Photo800x480_7 from "../img/thumb/photo-800x480--7.jpg";
import Frame100x60 from "../img/thumb/frame-100x60.png";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import ImageFrame100x125 from "../img/thumb/frame-100x125.png";

export default function Home(prop) {

    let [banner, setBanner] = React.useState(null);
    let [internal, setInternal] = React.useState(null);
    let [operatingResults, setOperatingResults] = React.useState(null);
    let [quote, setQuote] = React.useState(null);
    let [announcement, setAnnouncement] = React.useState(null);
    let [infographic, setInfographic] = React.useState(null);
    let [newsCategory, setNewsCategory] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const bannerListing = await getBanner();
                setBanner(bannerListing);

                const quoteView = await getQuote();
                setQuote(quoteView);

                const newCategoryList = await getNewsCategory();
                setNewsCategory(newCategoryList);

                const announcementListing = await getAnnouncement();
                setAnnouncement(announcementListing);

                const infographicListing = await getInfographic();
                setInfographic(infographicListing);

                const internalListing = await getInternal();
                setInternal(internalListing);

                const operatingResultsListing = await getOperatingResults();
                setOperatingResults(operatingResultsListing);

            } catch (e) {
                //
            }
        })();
    }, []);

    async function getBanner() {
        const response = await fetch(Config.apiUrl +'banner/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getQuote() {
        const response = await fetch(Config.apiUrl +'quote/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getInternal() {
        const response = await fetch(Config.apiUrl +'internal/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getOperatingResults() {
        const response = await fetch(Config.apiUrl +'operatingResults/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                startItem: 0,
                itemPerpage: 5
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getAnnouncement() {
        const response = await fetch(Config.apiUrl +'announcement/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                startItem: 0,
                itemPerpage: 4
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getInfographic() {
        const response = await fetch(Config.apiUrl +'infographic/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                startItem: 0,
                itemPerpage: 4
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getNewsCategory() {
        const response = await fetch(Config.apiUrl +'newsCategory/listWithNews', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            {
                banner !== null && banner.count > 0 ?
                    <>
                        <div className="section section-banner main">
                            <div className="swiper-container swiper-banner">
                                <div className="swiper-wrapper">
                                    {
                                        banner.rows.map((row, index) => {
                                            return (
                                                <div key={index} className="swiper-slide">
                                                    <img src={Config.fileUpload + 'banner/' + row?.image} alt="" />
                                                    <div className="container">
                                                        <div className="banner-caption">
                                                            <div className="logo">
                                                                <img className="w-100" src={LogoWhite} alt={prop.lang === 'en' ? row.title_en:row.title} />
                                                            </div>
                                                            <h3>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</h3>
                                                            {
                                                                prop.lang === 'en' ? 
                                                                    (row.link_en && row.link_text_en ? <a href={row.link_en} className="btn btn-light d-inline-block px-4 mt-2" target="_blank">{row.link_text_en}</a> : '') :
                                                                        (row.link && row.link_text ? <a href={row.link} className="btn btn-light d-inline-block px-4 mt-2" target="_blank">{row.link_text}</a> : '')
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                            {
                                banner.count > 1 ? <div className="swiper-pagination"></div> : ''
                            }

                        </div>
                    </> : ''
            }

            {
                quote !== null ?
                    <>
                        <div className="section">
                            <div className="container">
                                <div className="row g-sm-5 g-4">
                                    {
                                        quote.image ?
                                            <div className="col-xxl-6">
                                                <img className="w-100" style={{borderRadius:"8px"}} src={Config.fileUpload + 'quote/' + quote.image} alt="" />
                                            </div>
                                            : ''
                                    }

                                    <div className={"text-center" + (quote.image ? ' col-xxl-6':' col-xxl-12')}>
                                        <div className="hgroup w-icon-quotes">
                                            <img className="icons svg-js left" src={IconQuote} alt="quotes" />
                                                <h2 className="text-primary">{prop.lang === 'en' ? quote.title_en:quote.title}</h2>
                                                <img className="icons svg-js right" src={IconQuote}  alt="quotes" />
                                        </div>
                                        <p className="fs-18 text-body-dark">{prop.lang === 'en' ? quote.detail_en:quote.detail}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </> : ''
            }

            <div className="section" data-aos="fade-in">
                <div className="background bg-rounded-top-left page-dark-disable"
                     style={{backgroundImage: 'url(' + Photo1920x656_1 + ')'}}></div>
                <div className="background bg-rounded-top-left page-dark-visible"
                     style={{backgroundImage: 'url(' + Photo1920x656_2 + ')'}}></div>

                <div className="container">
                    <h2 className="text-center">{prop.lang === 'en' ? 'HTCR News':'ข่าวสารจาก ศชวซ.'}</h2>
                    <ul className="nav nav-links nav-color-custom">
                        {
                            newsCategory !== null && newsCategory.count > 0 ?
                                <>
                                    {
                                        newsCategory.rows.map((row, index) => {
                                            return (
                                                <li key={index}>
                                                    <a href="#" className={index === 0 ? "active":""} data-bs-toggle="tab" id={"news-tab" + index} data-bs-target={"#news" + index}>
                                                        <span className="line-animate">{prop.lang === 'en' ? row.title_en:row.title}</span>
                                                    </a>
                                                </li>
                                            )
                                        })
                                    }
                                </> : ''
                        }
                        <li>
                            <a href="#" data-bs-toggle="tab" id="announcement-tab" data-bs-target="#announcement">
                                <span className="line-animate">{prop.lang === 'en' ? 'Announcement':'ประกาศ ศชวซ.'}</span>
                            </a>
                        </li>
                        <li>
                            <a href="#" data-bs-toggle="tab" id="infographic-tab" data-bs-target="#infographic">
                                <span className="line-animate">{prop.lang === 'en' ? 'Infographic':'Infographic'}</span>
                            </a>
                        </li>
                    </ul>

                    <div className="tab-content">
                        {
                            newsCategory !== null && newsCategory.count > 0 ?
                                <>
                                    {
                                        newsCategory.rows.map((row, index) => {
                                            return (
                                                <div key={index} className={"tab-pane fade" + (index === 0 ? " show active":"")} id={"news" + index} role="tabpanel" aria-labelledby={"news-tab" + index}>
                                                    <div className="row card-news-lists">
                                                        {
                                                            row.newsData.length > 0 ?
                                                                row.newsData.map((rs, idx) => {
                                                                    return (
                                                                        <div key={idx} className="col-xl-3 col-md-4 col-sm-6">
                                                                            <div className="card-news" data-aos="fade-in">
                                                                                <a href={prop.lang === 'en' ? '/en/news/detail/' + rs.slug:'/news/detail/' + rs.slug} className="card-link"></a>
                                                                                <div className="card-photo">
                                                                                    <div className="photo"
                                                                                         style={{backgroundImage: 'url("' + Config.fileUpload + 'news/' + rs.image + '")'}}>
                                                                                        <img src={Frame100x60} alt="" />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="card-body">
                                                                                    <h3>{Utils.cleanOutput(prop.lang === 'en' ? rs.title_en:rs.title)}</h3>
                                                                                    <p>{Utils.dateDMY(row.postDate, prop.lang, false)}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }) : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                                                        }
                                                    </div>

                                                    <div className="buttons">
                                                        <a className="btn btn-viewall" href={prop.lang === 'en' ? '/en/news/category/' + row.slug:'/news/category/' + row.slug}>
                                                            <span className="px-4">{prop.lang === 'en' ? 'View more':'ดูทั้งหมด'}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </> : ''
                        }
                        <div className="tab-pane fade" id="announcement" role="tabpanel" aria-labelledby="announcement-tab">
                            <div className="row g-3">
                                {
                                    announcement !== null && announcement.count > 0 ?
                                        <>
                                            {
                                                announcement.rows.map((row, index) => {
                                                    return (
                                                        <div key={index} className="col-12">
                                                            <div className="card-announcement">
                                                                <a href={(prop.lang === 'en' ? '/en':'') + '/announcement/detail/' + row.slug} className="card-link"></a>
                                                                <div className="card-date">
                                                                    <p>{Utils.getDay(row.postDate)}</p>
                                                                    <p>{Utils.getMonthYearShort(row.postDate, prop.lang)}</p>
                                                                </div>
                                                                <div className="card-body">
                                                                    <h3>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</h3>

                                                                    <p className="readmore">
                                                                        <span>{prop.lang === 'en' ? 'Read more':'อ่านต่อ'}</span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </> : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                                }
                            </div>

                            <div className="buttons">
                                <a className="btn btn-viewall" href={prop.lang === 'en' ? '/en/announcement':'/announcement'}>
                                    <span className="px-4">{prop.lang === 'en' ? 'View more':'ดูทั้งหมด'}</span>
                                </a>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="infographic" role="tabpanel" aria-labelledby="infographic-tab">
                            <div className="row card-news-lists">
                                {
                                    infographic !== null && infographic.count > 0 ?
                                        <>
                                            {
                                                infographic.rows.map((row, index) => {
                                                    return (
                                                        <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                                                            <div className="card-news" data-aos="fade-in">
                                                                <a href={(prop.lang === 'en' ? '/en':'') + '/infographic/detail/' + row.slug} className="card-link"></a>
                                                                <div className="card-photo">
                                                                    <div className="photo"
                                                                         style={{backgroundImage: 'url("' + Config.fileUpload + 'infographic/' + row.image + '")'}}>
                                                                        <img src={ImageFrame100x125} alt="" />
                                                                    </div>
                                                                </div>
                                                                <div className="card-body">
                                                                    <h3>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </> : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                                }
                            </div>

                            <div className="buttons">
                                <a className="btn btn-viewall" href={prop.lang === 'en' ? '/en/infographic':'/infographic'}>
                                    <span className="px-4">{prop.lang === 'en' ? 'View more':'ดูทั้งหมด'}</span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {
                operatingResults !== null && operatingResults.count > 0 ?
                    <>
                        <div className="section" data-aos="fade-in">
                            <div className="container">
                                <h2 className="text-center mb-sm-4 mb-3">{prop.lang === 'en' ? 'Operating Results':'ผลลัพธ์การดำเนินงาน'}</h2>

                                <div className="card-infos">
                                    <ul className="document-list">
                                        {
                                            operatingResults.rows.map((row, index) => {
                                                return (
                                                    <li key={index}>
                                                        <img className="icons" src={IconPdf} alt="PDF" />
                                                            <div>
                                                                <h3><a href={Config.fileUpload + 'operating_results/' + row.file} target="_blank">{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</a>
                                                                </h3>
                                                                <p>{Utils.dateDMY(row.postDate, prop.lang, false)}</p>
                                                            </div>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>

                                <div className="buttons pt-3">
                                    <Link to={prop.lang === 'en' ? '/en/operating_result':'/operating_result'} className="btn btn-viewall">
                                        <span className="px-4">{prop.lang === 'en' ? 'View all':'ดูทั้งหมด'}</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </> : ''
            }


            {
                internal !== null && internal.count > 0 ?
                    <>
                        <div className="section bg-light" data-aos="fade-in">
                            <div className="container">
                                <h2 className="text-center">{prop.lang === 'en' ? 'Partner':'หน่วยงานที่เกี่ยวข้อง'}</h2>
                                <div className="swiper-overflow institution">
                                    <div className="swiper-container swiper-card">
                                        <div className="swiper-wrapper">
                                            {
                                                internal.rows.map((row, index) => {
                                                    return (
                                                        <div key={index} className="swiper-slide">
                                                            {
                                                                row.link !== null ? <Link to={row.link} target="_blank" title={prop.lang === 'en' ? row.title_en:row.title}><img src={Config.fileUpload + 'internal/' + row?.image} alt={prop.lang === 'en' ? row.title_en:row.title} className="logo" title={Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)} /></Link> : <img src={Config.fileUpload + 'internal/' + row?.image} alt={prop.lang === 'en' ? row.title_en:row.title} className="logo" />
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>

                                    {
                                        internal.count > 6 ?
                                            <>
                                                <div className="swiper-pagination d-flex d-lg-none"></div>
                                                <div className="swiper-button swiper-button-prev"><span
                                                    className="icons"></span></div>
                                                <div className="swiper-button swiper-button-next"><span
                                                    className="icons"></span></div>
                                            </>
                                            : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </> : ''
            }
        </>
    );
} 